import { apiClient } from "./apiClient";

export const teamApi = {
  // Assignable people, with their user_id. The task form used to make the
  // user type that number from memory (#190).
  listMembers: () => apiClient.get("/team/members").then((r) => r.data),
  listTasks: (status) => apiClient.get("/team/tasks", { params: { status } }).then((r) => r.data),
  getTask: (taskId) => apiClient.get(`/team/tasks/${taskId}`).then((r) => r.data),
  createTask: (payload) => apiClient.post("/team/tasks", payload).then((r) => r.data),
  updateTask: (taskId, status) => apiClient.put(`/team/tasks/${taskId}`, { status }).then((r) => r.data),
  deleteTask: (taskId) => apiClient.delete(`/team/tasks/${taskId}`).then((r) => r.data),

  listTemplates: () => apiClient.get("/team/task-templates").then((r) => r.data),
  createTemplate: (payload) => apiClient.post("/team/task-templates", payload).then((r) => r.data),
  deleteTemplate: (templateId) => apiClient.delete(`/team/task-templates/${templateId}`).then((r) => r.data),

  // Filters (#314): who, and between when. Omitted params are simply not
  // sent, so an unfiltered call behaves exactly as it always did.
  //
  // These NARROW what RLS already permits and can never widen it, which
  // is why passing somebody else's user_id cannot become a way to read
  // another team.
  activityFeed: (filters = {}) =>
    apiClient
      .get("/team/activity-feed", {
        params: {
          user_id: filters.userId || undefined,
          since: filters.since || undefined,
          until: filters.until || undefined,
        },
      })
      .then((r) => r.data),

  listComments: (hiveId) => apiClient.get("/team/comments", { params: { hive_id: hiveId } }).then((r) => r.data),
  addComment: (payload) => apiClient.post("/team/comments", payload).then((r) => r.data),
  updateComment: (commentId, comment) => apiClient.put(`/team/comments/${commentId}`, { comment }).then((r) => r.data),
  deleteComment: (commentId) => apiClient.delete(`/team/comments/${commentId}`).then((r) => r.data),

  listHandoffs: (completed) => apiClient.get("/team/handoffs", { params: { completed } }).then((r) => r.data),
  /*
   * Inspections you could hand off, by hive and date. The form asked for
   * an "Inspection ID" -- app.HiveActions' action_id, which appears
   * nowhere in the UI.
   */
  handoffCandidates: () => apiClient.get("/team/handoffs/candidates").then((r) => r.data),
  handoff: (payload) => apiClient.post("/team/handoff", payload).then((r) => r.data),
  completeHandoff: (handoffId, notes) => apiClient.put(`/team/handoffs/${handoffId}/complete`, { notes }).then((r) => r.data),
  /*
   * Which of two colliding handoffs is the right one (#368).
   *
   * Two people out of signal can hand the same inspection to different
   * teammates; the server marks both contested rather than letting the
   * later sync silently win. Web gets this even though it cannot CREATE
   * the collision -- the desk is where somebody notices it, and a
   * contest only the phone could settle would sit there.
   */
  settleHandoff: (handoffId) => apiClient.put(`/team/handoffs/${handoffId}/settle`).then((r) => r.data),

  listNotifications: (unreadOnly) => apiClient.get("/team/notifications", { params: { unread_only: unreadOnly } }).then((r) => r.data),
  markNotificationRead: (notificationId) => apiClient.put(`/team/notifications/${notificationId}/read`).then((r) => r.data),
  markAllNotificationsRead: () => apiClient.put("/team/notifications/read-all").then((r) => r.data),
};
